import React from "react";
import '../Pages/Style.css';

const Footer = () => (
  <footer className=" container-fluid" id="footer">
    <div className="flex-grow-1 container mt-4" id="footer-item">
      <div className="row text-start text-md-start justify-content-between">
        {/* Column 1 - Contact */}
        <div className="col-md-2">
          <h5>BROWSE</h5>
          <ul className="list-unstyled">
            <li> <i className="bi bi-arrow-right ms-3 me-2" style={{ fontWeight: 'bold', fontSize: '1.1rem' }}></i><a href="/" className="text-decoration-none text-white" >Home</a></li>
            <li> <i className="bi bi-arrow-right ms-3 me-2" style={{ fontWeight: 'bold', fontSize: '1.1rem' }}></i><a href="https://delightconsultancy.in/about" className="text-decoration-none text-white">About US</a></li>
            <li> <i className="bi bi-arrow-right ms-3 me-2" style={{ fontWeight: 'bold', fontSize: '1.1rem' }}></i><a href="https://delightconsultancy.in/job" className="text-decoration-none text-white">jobs</a></li>
            <li> <i className="bi bi-arrow-right ms-3 me-2" style={{ fontWeight: 'bold', fontSize: '1.1rem' }}></i><a href="https://delightconsultancy.in/recruiting" className="text-decoration-none text-white">Recruiting</a></li>
            <li> <i className="bi bi-arrow-right ms-3 me-2" style={{ fontWeight: 'bold', fontSize: '1.1rem' }}></i><a href="https://delightconsultancy.in/career" className="text-decoration-none text-white">Career</a></li>
            <li> <i className="bi bi-arrow-right ms-3 me-2" style={{ fontWeight: 'bold', fontSize: '1.1rem' }}></i><a href="https://delightconsultancy.in/contact" className="text-decoration-none text-white">Contact Us</a></li>
          </ul>
        </div>
        <div className="col-md-4">
          <h5>DELIGHT CONSULTANCY</h5>
          <ul className="list-unstyled">
            <p>Welcome to Delight Consultancy, your trusted partner in innovative technology and business solutions. We specialize in providing cutting-edge services designed to enhance your business performance, streamline operations, and boost productivity.  </p>

          </ul>
        </div>








        {/* Column 5 - Social Media */}
        <div className="col-md-6">
          <h5>CONTACT US</h5>
          <ul className="list-unstyled">
            <li>
              Delight consultancy
              #36, 1st main, 12th Cross
              Annsandrapalya, Hal.
            </li>
            <section className="social-icons-section1">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon bg-primary">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="https://wa.me/1234567890" target="_blank" rel="noopener noreferrer" className="social-icon bg-success">
                <i className="bi bi-whatsapp"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-icon bg-danger">
                <i className="bi bi-youtube"></i>
              </a>
              <a href="https://google.com" target="_blank" rel="noopener noreferrer" className="social-icon bg-danger">
                <i className="bi bi-google"></i>
              </a>

            </section>

          </ul>
        </div>
      </div>
    </div>
    <div className="container-fluid" id="copyright">
      <div className="text-center ">
        <h6>
          Copyright © 2025 Delight Consultancy.&nbsp;&nbsp;
          <span className="ms-2 me-2">All Rights Reserved.</span>
          <span className="ms-2">Designed by
            <a href="https://hostsky.in/" target="_blank" rel="noopener noreferrer" className="ms-1">Hostsky</a>
          </span>
        </h6>
      </div>

    </div>
  </footer>
)
export default Footer;
